import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { IAuthenticationService } from '../interfaces/authentication.abstract.service';
import { IStorageService } from '../interfaces/storage.abstract.service';
import { PershingHttpUtil } from '../utils/pershing-http.util';

@Injectable()
export class AuthenticationService implements IAuthenticationService {
    TOKEN_NAME: string = 'pershingAuthToken';
    loginSubject: Subject<any> = new Subject<any>();
    logoutSubject: Subject<any> = new Subject<any>();
    isUserLoggedIn: boolean = false; // this will be set post dasf login

    constructor(private http: HttpClient, private storage: IStorageService) { }

    /**
     * Authenticates the user credentials via POST request and a promise is returned.
     *
     * The method returns a Promise where the httpClient makes a POST request and
     * returns an Observable that can be subscribed to. The .subscribe() is necessary
     * to invoke the POST request. Upon the onNext callback of the Observable, the
     * Promise is then resolved.
     *
     * returnCode:
     *      0- Sucess
     *      1- Invalid password
     *      2- Invalid userId
     *      3- System error
     *
     * @param userId
     * @param password
     */
    authenticate(userId: string, password: string): Promise<any> {
        let headers = { 'Content-Type': 'application/json' };
        // Pass in the interceptors you want to disable. Accepts an optional headers params
        let options = PershingHttpUtil.disableInterceptors([ 'jwt', 'esf' ], headers);

        let body = {'userid': userId, 'password': password};

        // Post Request with responseType in options https://github.com/angular/angular/issues/18586
        return new Promise((resolve, reject) => {
            this.http.post('https://netx360wealth-internalv2.dev.bnymellon.net/dev-netx360-jwt-login-svc-app/dasf-test-login', body, { ...options, responseType: 'json' })
            .subscribe(response => { // Need to call subscribe to make the actual call for HttpClient
                let returnCode = parseInt(response['returncode'], 10);
                if (returnCode === 0) {
                    this.storage.setItem(this.TOKEN_NAME, response['esfjwt']);
                }
                resolve(returnCode);
            });
        });
    }

    /*
        TODO: implement below to support stateless service call with explict token (e.g. JWT) w/o cookie
        1) check if user still logged in
        2) check if token exist in Storage service
        3) check if token is expired (local policy)
            a) if expired, refresh the token by calling backend and set token
        4) return token string
    */
    getToken(): string {
        return this.storage.hasItem(this.TOKEN_NAME) ? this.storage.getItem(this.TOKEN_NAME) : null;
    }

    /**
     * Get the esf cookie string. This is temporary
     */
    getCookie(): string {
        return this.storage.hasItem('cookie') ? this.storage.getItem('cookie') : null;
    }

    /*
        TODO: need to implement real login. Potentially using StorageService to store/cache logged user information.
        1) check if user authenticated in StorageService (local)
        2) check local session policy
    */
    isLoggedIn(): boolean {
        return (this.storage.hasItem(this.TOKEN_NAME) || this.isUserLoggedIn); // TODO: Check if token isn't expired?
    }

    /**
     * TODO: temporary fix might need to change
     *  added to set the isUserLoggedIn value after dasf login
     * used is isLoggedIn() to identify logged in user
     *
     */
    setUserLoggedIn(): void {
        this.isUserLoggedIn = true;
    }

    logout(): void {
        this.storage.clear();
    }
}
